<template>
  <a-spin :spinning="saveLoading">
    <div class="account-settings-info-view">
      <a-row :gutter="16">
        <a-col :md="24" :lg="16">
          <a-form layout="vertical" :form="form">
            <a-form-item label="商户网址">
              <span>{{formData.site_url}}</span>
            </a-form-item>
            <a-form-item label="独立版二维码">
              <div
                style="width:94px;height:94px;padding:3px;border:1px solid #d9d9d9;border-radius:3px"
              >
                <img
                  @mouseover="onMouseover"
                  @mouseleave="onMouseleave"
                  style="width:100%;height:100%;display:block"
                  :src="formData.site_pic"
                  alt="独立版二维码"
                  srcset
                />
              </div>
            </a-form-item>
            <a-form-item label="商家名称">
              <a-input placeholder="名称" v-model="formData.name" />
            </a-form-item>
            <a-form-item label="商家描述">
              <a-textarea rows="4" v-model="formData.desc" placeholder="商家描述" />
            </a-form-item>


            <a-form-item label="LOGO" extra="显示在列表页,推荐尺寸750x750,推荐格式jpg">
              <pic-uploader :file-list="formData.pic" />
            </a-form-item>

            <a-form-item label="背景图" extra="显示详情页,推荐宽度750x525,推荐格式jpg">
              <pic-uploader :file-list="formData.pics" />
            </a-form-item>


            <a-form-item label="H5分享标题">
              <a-input placeholder="名称" v-model="formData.h5_share_title" />
            </a-form-item>
            <a-form-item label="H5分享LOGO">
              <pic-uploader :file-list="formData.h5_share_logo" :numberLimit="1" />
            </a-form-item>

            <a-form-item label="H5分享描述">
              <a-textarea rows="4" v-model="formData.h5_share_desc" placeholder="h5分享描述" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开放时间" hasFeedback>
              <a-time-picker
                :default-value="moment(formData.time_start, 'HH:mm')"
                format="HH:mm"
                :value="moment(formData.time_start, 'HH:mm')"
                @change="onTimeStartChange"
              />-
              <a-time-picker
                :default-value="moment(formData.time_end, 'HH:mm')"
                format="HH:mm"
                :value="moment(formData.time_end, 'HH:mm')"
                @change="onTimeEndChange"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="景区等级" hasFeedback>
              <a-rate v-model="formData.level" />
            </a-form-item>
            <a-form-item label="联系电话" hasFeedback>
              <a-input
                v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入商家联系电话' }]}
        ]"
                placeholder="请输入商家联系电话"
              />
            </a-form-item>

            <a-form-item label="地址" hasFeedback>
              <a-input
                v-decorator="[
          'address',
          {rules: [{ required: true, message: '请输入商家地址' }]}
        ]"
                placeholder="请输入商家地址"
              />
            </a-form-item>
            <a-form-item label="搜索热门关键字">
              <a-input v-model="formData.search_keywords" placeholder="搜索热门关键字" />
            </a-form-item>

            <a-form-item label="显示进群有福利">
              <r-switch
                :formData="formData"
                field="open_wechat_add"
                :checkedValue="1"
                :unCheckedValue="2"
                checkedChildren="开启"
                unCheckedChildren="关闭"
              />
            </a-form-item>
            <a-form-item v-show="formData.open_wechat_add==1 " label="进群二维码">
              <pic-uploader :file-list="formData.wechat_add_pic" :numberLimit="1" />
            </a-form-item>

            <a-form-item label="订单详情强制加好友">
              <r-switch
                :formData="formData"
                field="open_order_add_friend"
                :checkedValue="1"
                :unCheckedValue="2"
                checkedChildren="开启"
                unCheckedChildren="关闭"
              />
            </a-form-item>

            <a-form-item v-show="formData.open_order_add_friend==1 " label="微信号">
              <a-input placeholder="微信号" v-model="formData.order_add_friend_code" />
            </a-form-item>

            <a-form-item v-show="formData.open_order_add_friend==1 " label="二维码">
              <pic-uploader :file-list="formData.order_add_friend_pic" />
            </a-form-item>

            <a-form-item v-show="formData.open_order_add_friend==1 " label="话术">
              <a-input placeholder="微信号" v-model="formData.order_add_friend_text" />
            </a-form-item>
            <a-form-item label="图文介绍" >
              <UEditor style="width: 400px; height:520px;" :ueditorContent.sync="formData.content"></UEditor>
            </a-form-item>

            <a-form-item>
              <a-button type="primary" :loading="saveLoading" @click="submitForm">保存</a-button>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :md="24" v-if="false" :lg="8" :style="{ minHeight: '180px' }">
          <div class="ant-upload-preview" @click="$refs.modal.edit(1)">
            <a-icon type="cloud-upload-o" class="upload-icon" />
            <div class="mask">
              <a-icon type="plus" />
            </div>
            <img :src="option.img" />
          </div>
        </a-col>
      </a-row>
    </div>
  </a-spin>
</template>

<script>
import { businessSetting, getBusinessSetting } from '@/api/business'
import setting from '@/config/setting'
import moment from 'moment'
import RSwitch from '@/components/RSwitch/'
import UEditor from '@/components/UEditor/'
import PicUploader from '@/components/PicUploader/'
export default {
  components: {
    PicUploader,
    RSwitch,UEditor
  },
  data() {
    return {
      // cropper
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      saveLoading: false,
      form: this.$form.createForm(this),
      preview: {},
      option: {
        img: '/avatar2.jpg',
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 180,
        autoCropHeight: 180,
        fixedBox: true,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [1, 1]
      },
      formData: {
        name: '',
        desc: '',
        time_start: '00:00',
        time_end: '00:00',
        level: 0,
        pic: [],
        site_pic: [],
        site_url: '',
        pics: [],
        h5_share_title: '',
        h5_share_logo: [],
        h5_share_desc: '',
        search_keywords: '',
        open_order_add_friend: 2,
        open_wechat_add: 2,
        wechat_add_pic: [],
        order_add_friend_code: '',
        order_add_friend_pic: [],
        order_add_friend_text: '',
        content: ''
      }
    }
  },
  mounted() {
    let that = this
    that.fetch()
  },
  methods: {
    moment,
    fetch() {
      let that = this
      getBusinessSetting({})
        .then(res => {
          that.formData = res.data
          that.formData.time_start = res.data.time_start ? res.data.time_start : '00:00'
          that.formData.time_end = res.data.time_end ? res.data.time_end : '00:00'
          that.form.setFieldsValue({ ...res.data })
        })
        .catch(err => {})
    },

    getTimeMinute(time) {
      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      // var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60)

      return s
    },
    onTimeStartChange(time, timeString) {
      let that = this
      that.formData.time_start = timeString ? timeString : '00:00'
    },
    onTimeEndChange(time, timeString) {
      let that = this
      that.formData.time_end = timeString ? timeString : '00:00'
    },
    onMouseover() {
      console.log(1111)
    },
    onMouseleave() {
      console.log(2222)
    },
    submitForm(e) {
      let self = this
      if (
        self.getTimeMinute(self.formData.time_start) > 0 &&
        self.getTimeMinute(self.formData.time_start) >= self.getTimeMinute(self.formData.time_end)
      ) {
        self.$message.error('开放结束时间不能小于等于开始时间')
        return
      }
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          self.saveLoading = true
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          businessSetting(Object.assign(self.formData, values))
            .then(res => {
              self.$message.success('设置成功')
              self.saveLoading = false
            })
            .catch(err => {
              self.$message.error(err.data.msg)
              self.saveLoading = false
            })
        } else {
          console.log(err)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
